import { staticViewsActionTypes } from '.';

export const getDataStart = (view: StaticView) => ({
  type: staticViewsActionTypes.GET_DATA_START,
  payload: { view },
} as const);
export const getDataSuccess = (view: StaticView, data: GetDataSuccessPayload) => ({
  type: staticViewsActionTypes.GET_DATA_SUCCESS,
  payload: { view, data },
} as const);
export const getDataFail = (view: StaticView) => ({
  type: staticViewsActionTypes.GET_DATA_FAIL,
  payload: { view },
} as const);
export const setDataAfterSort = (view: StaticView, data: any) => ({
  type: staticViewsActionTypes.SET_DATA_AFTER_SORT,
  payload: { view, data },
} as const);
export const getDataNextPage = (view: StaticView) => ({
  type: staticViewsActionTypes.GET_DATA_NEXT_PAGE_START,
  payload: { view },
} as const);
export const getDataNextPageSuccess = (view: StaticView, data: any) => ({
  type: staticViewsActionTypes.GET_DATA_NEXT_PAGE_SUCCESS,
  payload: { view, data },
} as const);
export const getDataNextPageFail = (view: StaticView) => ({
  type: staticViewsActionTypes.GET_DATA_NEXT_PAGE_FAIL,
  payload: { view },
} as const);
export const setLoading = (view: StaticView) => ({
  type: staticViewsActionTypes.SET_LOADING,
  payload: { view },
} as const);
export const setSearch = (view: StaticView, search: ViewDataSet['search']) => ({
  type: staticViewsActionTypes.SET_SEARCH,
  payload: { view, search },
} as const);
export const init = (view: StaticView) => ({
  type: staticViewsActionTypes.INIT,
  payload: { view },
} as const);
export const initFinish = (view: StaticView) => ({
  type: staticViewsActionTypes.INIT_FINISH,
  payload: { view },
} as const);
export const setSelected = (view: StaticView, selected: ViewDataSet['selected']) => ({
  type: staticViewsActionTypes.SET_SELECTED,
  payload: { view, selected },
} as const);
export const setOrder = (view: StaticView, settings: ViewDataSet['sorting']) => ({
  type: staticViewsActionTypes.SET_ORDER,
  payload: { view, settings },
} as const);
export const setPage = (view: StaticView, page: ViewDataSet['page']) => ({
  type: staticViewsActionTypes.SET_PAGE,
  payload: { view, page },
} as const);
export const setDetailsLoading = (view: StaticView) => ({
  type: staticViewsActionTypes.SET_DETAILS_LOADING,
  payload: { view },
} as const);
export const getRecordDetails = (view: StaticView, id: string | number) => ({
  type: staticViewsActionTypes.RECORD_GET_DETAILS_START,
  payload: { view, id },
} as const);
export const getRecordDetailsSuccess = (view: StaticView, data: SingleObjectDataStructure, id: string | number) => ({
  type: staticViewsActionTypes.RECORD_GET_DETAILS_SUCCESS,
  payload: { view, data, id },
} as const);
export const getRecordDetailsFail = (view: StaticView) => ({
  type: staticViewsActionTypes.RECORD_GET_DETAILS_FAIL,
  payload: { view },
} as const);
export const getColumnsConfigSuccess = (view: StaticView, mainColumns: SingleColumn[], marksColumns?: SingleColumn[]) => ({
  type: staticViewsActionTypes.COLUMNS_GET_CONFIG_SUCCESS,
  payload: { view, mainColumns, marksColumns },
} as const);
export const getColumnsConfigFail = (view: StaticView) => ({
  type: staticViewsActionTypes.COLUMNS_GET_CONFIG_FAIL,
  payload: { view },
} as const);
export const changeColumnsSorting = (view: StaticView, sortingInfo: Helpers.SortingInfo) => ({
  type: staticViewsActionTypes.COLUMNS_CHANGE_SORTING,
  payload: { view, sortingInfo },
} as const);
export const saveColumnsUserSetup = (view: StaticView, selectedColumns: SelectedColumns) => ({
  type: staticViewsActionTypes.COLUMNS_SAVE_USER_SETUP_START,
  payload: { view, selectedColumns },
} as const);
export const saveColumnsUserSetupSuccess = (view: StaticView, data: SingleColumn[]) => ({
  type: staticViewsActionTypes.COLUMNS_SAVE_USER_SETUP_SUCCESS,
  payload: { view, data },
} as const);
export const selectFilterValues = (view: StaticView, filters: SelectFilterValuesPayload) => ({
  type: staticViewsActionTypes.FILTERS_SELECT_VALUES,
  payload: { view, filters },
} as const);
export const closeFilterCategory = (view: StaticView, filter: string) => ({
  type: staticViewsActionTypes.FILTERS_CLOSE_CATEGORY,
  payload: { view, filter },
} as const);
export const openFilterCategory = (view: StaticView, filtersGroups: FilterSettings) => ({
  type: staticViewsActionTypes.FILTERS_OPEN_CATEGORY,
  payload: { view, filtersGroups },
} as const);
// fixme: okresl interfejs dla payloady data
export const refreshFilterValueSuccess = (view: StaticView, data: { [key: string]: any[] }) => ({
  type: staticViewsActionTypes.FILTERS_REFRESH_VALUES_SUCCESS,
  payload: { view, data },
} as const);
export const refreshFilterValueFail = (view: StaticView) => ({
  type: staticViewsActionTypes.FILTERS_REFRESH_VALUES_FAIL,
  payload: { view },
} as const);
// fixme: okresl interfejs dla filtrow
export const getFiltersConfigSuccess = (view: StaticView, data: any[]) => ({
  type: staticViewsActionTypes.FILTERS_GET_CONFIG_SUCCESS,
  payload: { view, data },
} as const);
export const getFiltersConfigFail = (view: StaticView) => ({
  type: staticViewsActionTypes.FILTERS_GET_CONFIG_FAIL,
  payload: { view },
} as const);
export const refreshData = (view: StaticView) => ({
  type: staticViewsActionTypes.REFRESH_DATA_START,
  payload: { view },
} as const);
export const syncDataWithCache = (view: StaticView) => ({
  type: staticViewsActionTypes.SYNC_DATA_WITH_CACHE_START,
  payload: { view },
} as const);
export const syncDataWithCacheSuccess = (view: StaticView, data: Pick<WithCache, 'controlSum' | 'duration' | 'isUpToDate'>) => ({
  type: staticViewsActionTypes.SYNC_DATA_WITH_CACHE_SUCCESS,
  payload: { view, data },
} as const);
export const syncDataWithCacheFail = (view: StaticView) => ({
  type: staticViewsActionTypes.SYNC_DATA_WITH_CACHE_FAIL,
  payload: { view },
} as const);
